import React, { useState, useEffect } from "react";
import {
  BackButton,
  ThinTextField,
  ThinDropdown,
  ThinDropdownWithSearch,
  AddButton,
} from "../../common/GeneralComponent";
import { fetchData, submitFormWithErrors } from "../../../utils/functions";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/partials/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddRGC = () => {
  const [districts, setDistricts] = useState([]);
  const [loader, setLoader] = useState(true);
  const [generatedCode, setGeneratedCode] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await fetchData("districts", "GET");
        setDistricts(response.data || []);
        setLoader(false);
      } catch (error) {
        console.error("Error fetching districts:", error);
        toast.error("Failed to fetch districts");
        setLoader(false);
      }
    };
    fetchDistricts();
  }, []);

  const formik = useFormik({
    initialValues: {
      rgc_name: "",
      district_id: "",
      status: 1,
    },
    validationSchema: Yup.object({
      rgc_name: Yup.string()
        .required("RGC Name is required")
        .matches(
          /^[a-zA-Z\s]+$/,
          "RGC Name cannot contain Special Characters or Number"
        )
        .min(3, "RGC Name must be at least 3 characters long")
        .max(50, "RGC Name must be at most 50 characters long"),
      district_id: Yup.string().required("District is required"),
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        await fetchData("rgcs", "POST", values);
        toast.success("Created Successfully");
        navigate("/rgcs");
      } catch (error) {
        console.error("Creation failed:", error);
        toast.error(error.message || "Failed to create RGC");
        setLoader(false);
      }
    },
  });

  const generateCodeFromName = (name) => {
    if (name && name.length >= 2) {
      return name.substring(0, 2).toUpperCase();
    }
    return "";
  };

  return (
    <div className="w-full my-4 mx-auto">
      {loader && <Loader />}

      <div className="flex lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
          Create RGC
        </h1>
        <BackButton text="Back" to="/rgcs" />
      </div>
      <div className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4 mb-[7rem]">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b">
          <h1 className="lg:text-[0.875rem] text-[13px] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Create RGC
          </h1>
        </div>
        <form onSubmit={submitFormWithErrors(formik)} className="p-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 p-4 my-4">
            <ThinTextField
              label="RGC Name"
              name="rgc_name"
              id="rgc_name"
              type="text"
              value={formik.values.rgc_name}
              onChange={(e) => {
                formik.handleChange(e);
                const code = generateCodeFromName(e.target.value);
                setGeneratedCode(code);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.rgc_name && formik.errors.rgc_name}
              helperText={formik.touched.rgc_name && formik.errors.rgc_name}
            />
            <ThinDropdownWithSearch
              label="District"
              options={districts.map((d) => ({
                value: d.district_id || d.District_Id,
                label: d.district_name || d.District_Name,
              }))}
              value={formik.values.district_id}
              onChange={(value) => formik.setFieldValue("district_id", value)}
              onBlur={() => formik.setFieldTouched("district_id", true)}
              error={formik.touched.district_id && formik.errors.district_id}
              helperText={
                formik.touched.district_id && formik.errors.district_id
              }
            />
            <ThinDropdown
              label="Status"
              options={[
                { value: 1, label: "Active" },
                { value: 0, label: "In-Active" },
              ]}
              value={formik.values.status}
              onChange={(e) => formik.setFieldValue("status", e.target.value)}
              onBlur={formik.handleBlur}
              error={formik.touched.status && formik.errors.status}
            />
          </div>
          <div className="p-4">
            <AddButton
              text="Submit"
              type="Submit"
              disabled={formik.isSubmitting}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddRGC;
